// Module
var code = "<div class=\"mb-obj-list search\"> <div id=\"mb-search-input\" class=\"search-container\"></div> <div id=\"mb-object-search\"></div> </div> ";
// Exports
export default code;